import { Moment } from "moment";
import { PlannerEventId } from "./ids";

export default class PlannerEventCreated {
  id!: PlannerEventId;
  suggestedPlannedVisit!: Moment;
  suggestedPreferredPickup: Moment | null = null;
}